import { useMemo } from 'react';
import type { FilterOption } from '@odo/shared-ui';
import { usePracticeOptions } from '../../../../hooks/useBilling';
import { SearchSelect } from '../../SearchSelect';
import { CREATE_PO_FIELD_LABEL_CLASS } from './createPoFieldStyles';

interface SelectPracticeStepProps {
    practiceId: string | null;
    onChange: (practiceId: string | null) => void;
}

export function SelectPracticeStep({ practiceId, onChange }: SelectPracticeStepProps) {
    const { practices, isLoading } = usePracticeOptions();

    const options = useMemo<FilterOption[]>(
        () =>
            practices.map((p) =>
                p.doctorName
                    ? {
                          value: p.id,
                          label: p.name,
                          sublabel: `Dr. ${p.doctorName}`,
                          keywords: [`Dr. ${p.doctorName}`, p.doctorName]
                      }
                    : { value: p.id, label: p.name }
            ),
        [practices]
    );

    return (
        <div>
            <label className={CREATE_PO_FIELD_LABEL_CLASS}>Practice *</label>
            <SearchSelect
                value={practiceId ?? ''}
                options={options}
                onChange={(value) => onChange(value || null)}
                placeholder={isLoading ? 'Loading practices…' : 'Select practice…'}
                searchPlaceholder="Search practices…"
                disabled={isLoading}
            />
        </div>
    );
}
